import type { ChannelType, ChatResponse } from '@vitrin-ai/shared';

export interface SendMessageInput {
  apiUrl: string;
  storeId: string;
  conversationId?: string;
  message: string;
  channel: ChannelType;
}

export async function sendMessage(input: SendMessageInput): Promise<ChatResponse> {
  const response = await fetch(`${input.apiUrl}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      storeId: input.storeId,
      conversationId: input.conversationId,
      channel: input.channel,
      message: input.message,
    }),
  });

  if (!response.ok) {
    throw new Error(`Sohbet isteği başarısız oldu (${response.status}).`);
  }

  return (await response.json()) as ChatResponse;
}

// Sayfa navigasyonuyla yarışan, kritik olmayan bir çağrı — hatası widget'ı bozmamalı.
export function trackClick(apiUrl: string, conversationId: string, productId: string): void {
  try {
    fetch(`${apiUrl}/track-click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ conversationId, productId }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Tıklama takibi başarısız olsa da kullanıcı deneyimini etkilememeli.
  }
}
